<template>
  <div :class="this.offer.premium && 'opacity50'" class="d-inline-block position-relative">
    <div class="offer-discount d-flex align-items-center justify-content-center">
      <div>
        <!-- <p class="m-0"> -->
          {{ this.discountValueLabel }}
        <!-- </p> -->
      </div>
      <!-- <div v-if="this.offer.premium" class="premium-icon">
        <img :src="require('@/assets/images/premium.svg')" />
      </div> -->
    </div>
    <div class="offer-wrapper">
      <div v-if="this.image" class="offer-preview-image" :style="{ 'background-image': `url(${this.image})` }"></div>
      <div v-else class="offer-preview-image"
        :style="{ 'background-image': `url(${this.getImagePath() + 'offers/offer_' + this.offer.id + '.png'})` }"></div>
      <!-- <img v-else class="offer-image" :src="this.getImagePath() + 'offers/offer_' + this.offer.id + '.png'"
        @error="($event.target.src = require('@/assets/images/offer_0.svg'))" /> -->
      <h5 class="add-ellipsis min-height-48">{{ this.offer.name }}</h5>
      <div class="offer-price">
        {{ (this.offer.price + " " + this.offer.currency) }}
      </div>
      <!-- :disabled="this.offer.premium" -->
      <div class="contact-details-wrapper">
        <a class="button-all button-orange" @click="openOfferDetails()">{{
          $t("details")
        }}</a>
              <PersonContactOnly :person="this.offer.person" :user="this.user" :offerName="this.offer.name" :offerId="this.offer.id" />
      </div>
      <div class="contact-details-wrapper">
        <div class="text">
              <p>{{ $t("addedByLabel") }}</p>
              <p class="user-added">
                {{
                    this.offer.person.first_name +
                    " " +
                    this.offer.person.last_name
                }}

              </p>
              <br clear="all" />
              <p>
                {{
                    this.offer.person.company_name
                }}
              </p>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonContactOnly from "@/components/fragments/PersonContactOnly.vue";

export default {
  name: "OfferCase",
  components: { PersonContactOnly },

  props: {
    user: Object,
    offer: Object,
    image: String,
    isDiscount: Boolean,
    discountValue: Number,
    currency: String,
  },
  data() {
    return {
      // offer: null,
    };
  },
  methods: {
    // getOfferDetails() {},
    openOfferDetails() {
      // if (!this.offer.premium) {
      this.$emit("showDetails", this.offer);
      // }
      // this.selectedOfferId = offer.id;
      // this.selectedOffer = offer;
      // this.showModalPopup("modal_popup_offer", true);
    },
  },
  computed: {
    discountValueLabel: function () {
      if (this.offer.id > 0) {
        return (
          "-" +
          (this.offer.discount > 0
            ? this.offer.discount + "%"
            : this.offer.deduction + "" + this.offer.currency)
        );
      } else {
        return (
          "-" +
          this.discountValue +
          (this.isDiscount ? "%" : "" + this.currency)
        );
      }
    },
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.padding65 {
  position: relative;
  top: -65px;
}

.min-height-48 {
  min-height: 48px;
}

.add-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
